import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';

export const mlTestimonialBlockCardMockData = {
  cta: {
    label: "Jessica's Story",
    href: '/',
    variant: EClickableVariants.DIMINUTIVE,
  },
  headline: 'What our new homeowners are saying:',
  images: [
    {
      entry_title: 'Image 1',
      alt: 'Alt',
      mobile_image_url: '/assets/home_plan.jpeg',
      tablet_image_url: '/assets/home_plan.jpeg',
      desktop_image_url: '/assets/home_plan.jpeg',
    },
    {
      entry_title: 'Image 2',
      alt: 'Alt',
      mobile_image_url: '/assets/image_card.jpg',
      tablet_image_url: '/assets/image_card.jpg',
      desktop_image_url: '/assets/image_card.jpg',
    },
  ],
  quote:
    '“Watching our dream home come to life was incredible, but seeing it all completed—it’s beyond what we could have imagined. It’s not just a house, it’s our forever home.”',
};
